import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
} from "@material-ui/core";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack } from "@material-ui/icons";
import PODetail from "../Invoices/NewInvoice/Tables/PoDetail_Table";
import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  getImportPoData,
  updateIPInvoiceByImport,
  getBatchInvoiceDetails,
} from "../Invoices/actions";
import moment from "moment";
import InvoiceRadioButtons from "../Invoices/Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Invoices/Components/InvoiceDetails/InvoiceTextFields";
import InvoiceDetailTextField from "../Invoices/Components/InvoiceDetails/InvoiceDetailTextFields";
// import PaymentDetail from "../Components/PaymentDetails/PaymentDetail";
import PaymentDetail from "../Invoices/Components/PaymentDetails/PaymentDetail.js";
import PaymentDetailsTextField from "../Invoices/Components/PaymentDetails/PaymentDetailsTextField.js";
import TaxDetail from "../Invoices/Components/TaxDetails/TaxDetails";
import TaxDetailTextField from "../Invoices/Components/TaxDetails/TaxDetailTextField";
import { useNavigate } from "react-router-dom";
import WarningBox from "../Invoices/Components/WarningBox";
import { useParams } from "react-router-dom";
import Heading from "../../StyledComponents/Heading/Heading";
import InvoiceCheckboxes from "../Invoices/Components/InvoiceDetails/InvoiceCheckboxes";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import CustomSnackbar from "../../CustomSnackbar";
import getParameterByName from "../../Functions/functions";
import { getUserRoles } from "../Home/actions";
import InvoiceGuideLine from "../Invoices/NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import CommentHistory from "../Invoices/NewInvoice/Tables/CommentHistory";
import OldDateWarning from "../Invoices/NewInvoice/InvoiceGuidLines/OldDateWarning";
import PaymentImport from "../Invoices/NewInvoice/Payment/PaymentImport";
import GL_Table_ProcessInvoice from "../Invoices/NewInvoice/Tables/GL_Table_ProcessInvoice";
import PoDetail_Table_Import from "../Invoices/NewInvoice/Tables/PoDetail_Table_Import";
import TaxTable_Short from "../Invoices/NewInvoice/Tables/Tax_Table_Short";
import TaxTable_Short_Import from "../Invoices/NewInvoice/Tables/Tax_Table_Short_import";
import Vendor_Table from "../Invoices/NewInvoice/Tables/Vendor_Table";
import VendorTaxTable from "../Invoices/NewInvoice/Tables/Vendor_Tax_Detail";
import Card from "../../StyledComponents/Card/Card";
import AttachmentsCover from "../../components/Attachments/AttachmentsCover";
import ConfirmationModal from "../../components/ConfirmModal/ConfirmationModal";
import VFPostingDetail from "./VFPostingDetail";
import Spinner from "../Spinner/Spinnerv2";

const useStyles = makeStyles(dashboardStyle);

const VFInvoiceDetail = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const invoiceId = getParameterByName("inv");
  const vendorCode = getParameterByName("vendorCode");

  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: "013fa4f6-3525-434b-8293-c1a72ef1526f",
    roleName: "IP",
  };

  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  const [rolesLoading, setRolesLoading] = useState(false);

  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");

  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);

  // const [isLoading, setIsLoading] = useState(true);

  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
    invoice_Type: [],
    // invoice_Details:[],
  });

  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    comments: "",
    po_Date: new Date().toString(),
    plant_Code: "",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: "",
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,
    courier_Tracking_No: "",
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    cnic: "",

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    due_Date: new Date(),

    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: moment().format("YYYY-MM-DD"),
    fiscal_Year: "",
    document_No: "",
    documents_Reference: "",
    document_date: moment().format("YYYY-MM-DD"),
    newInvoice_Desc: "",

    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    // for Payment detail ("invoice_Payment" for po normal isInititor invoice).
    // ("invoice_Payment_Details" for import invoice) (will chnage).
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: moment().format("YYYY-MM-DD"),
    },

    // Tax Table data (invoice_TaxDetails for po normal isInititor invoice)
    // ("invoice_Tax_Details" for import invoice) (will chnage).
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    // invoice_Details:[],
    verified: false,
  });

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const [importPaymentDetail, setImportPaymentDetail] = useState({
    invoice_Payment_Details: [],
  });
  const invNo = getParameterByName("inv");
  const [newFormState, setNewFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    courier_Tracking_No: "",
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: new Date(),
    fiscal_Year: "",
    document_No: "",
    documents_Reference: "",
    document_date: moment().format("YYYY-MM-DD"),
    newInvoice_Desc: "",

    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: moment().format("YYYY-MM-DD"),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "", // D/C (debit/ credit)
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],

    verified: false,
  });

  const [debitBalance, setDebitBalance] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);

  const [invoiceTaxDetail, setInvoiceTaxDetail] = useState({
    invoice_TaxDetails: [],
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [totalGrnAmount, setTotalGrnAmount] = useState(0);
  const [balance, setBalance] = useState(0);

  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [gLAccountTotal, setGLAccountTotal] = useState(0);

  useEffect(() => {
    if (newFormState?.invoicePORef_List?.length > 0) {
      let counts = 0;
      for (let i = 0; i < newFormState?.invoicePORef_List?.length; i++) {
        const item = newFormState?.invoicePORef_List[i];
        counts = counts + parseFloat(item.inpuT_VAL);
      }
      setTotalGrnAmount(counts);
    }
  }, [newFormState.invoicePORef_List]);

  // to set po based true or false.
  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);

  useEffect(() => {
    if (newFormState.pO_Based) {
      const tax_invAmt =
        parseFloat(newFormState?.salesTaxAmount) +
        parseFloat(newFormState?.invoice_Amount);
      const bal =
        Number(totalGrnAmount) +
        Number(newFormState?.salesTaxAmount || 0) +
        gLAccountTotal -
        Number(newFormState?.invoice_Amount || 0);
      const c = Number(bal.toFixed(3));
      setBalance(c);
    }
  }, [
    newFormState?.salesTaxAmount,
    newFormState?.invoice_Amount,
    totalGrnAmount,
    gLAccountTotal,
  ]);

  useEffect(() => {
    let debitt = 0;
    let creditt = 0;
    if (importPaymentDetail?.invoice_Payment_Details.length > 0) {
      for (
        let i = 0;
        i < importPaymentDetail?.invoice_Payment_Details?.length;
        i++
      ) {
        const ele = importPaymentDetail?.invoice_Payment_Details[i];
        if (ele.postingKey === "40") {
          // debit
          debitt = debitt + parseFloat(ele?.amount || 0);
        }
        if (ele.postingKey === "50") {
          // credit
          creditt = creditt + parseFloat(ele?.amount || 0);
        }
        if (ele.postingKey === "31") {
          creditt = creditt + parseFloat(ele?.amount || 0);
        }
      }
      setDebitBalance(debitt);
      setCreditBalance(creditt);
    }
  }, [importPaymentDetail?.invoice_Payment_Details]);

  useEffect(() => {
    if (formState.invoice_Amount !== "") {
      setCreditBalance(formState.invoice_Amount);
    }
  }, [formState.invoice_Amount]);

  useEffect(() => {
    setBalance(creditBalance - debitBalance);
  }, [creditBalance, debitBalance]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setNewFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }

    return show;
  };

  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    clearState(setFormState);
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };

  const submitHandler = () => {
    if (formState?.isImport) {
      updateIPInvoiceByImport(
        newFormState,
        invoiceTaxDetail,
        importPaymentDetail,
        setNewFormState,
        poBasedState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        navigate
      );
      setOpenWarningBox(false);
    } else if (formState?.isInitiator) {
      updateIPInvoice(
        newFormState,
        setNewFormState,
        poBasedState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        navigate
      );
      setOpenWarningBox(false);
    }
    setOpenWarningBox(false);
  };

  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "postingKey",
      "postingKey",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("sglInd", "sglInd", setFormState, setMultipleData);
    getRefrenceDataList("tType", "tType", setFormState, setMultipleData);

    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("Currency", "currency", setFormState, setMultipleData);
    getUserRoles(setRoles, setRolesLoading);

    if (invoicePayload && role) {
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);

      // getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);

      getBatchInvoiceDetails(
        () => {},
        () => {},
        setMultipleData,
        invoicePayload,
        () => {},
        setFormState,
        setDataLoading,
        setPoBasedState
      );
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
      // if (!formState.isImport) {
      // getAllInvoiceDetailByInvoiceId(
      //   setFormState,
      //   setMultipleData,
      //   invoicePayload?.Invoice_id,
      //   () => {},
      //   setImportPaymentDetail,
      //   importPaymentDetail,
      //   () => {},
      //   () => {},
      //   "",
      //   () => {}
      // );
      // }
    }
  }, []);
  const [po_Loading, setPo_Loading] = useState(false);

  useEffect(() => {
    if (
      formState?.isImport &&
      formState?.pO_No &&
      formState?.invoicePORef_List?.length === 0
    ) {
      getImportPoData(
        formState?.pO_No,
        invoicePayload?.Invoice_id,
        setFormState,
        setPo_Loading
      );
    }
  }, [formState?.isImport, formState?.pO_No]);

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }

    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    setAttachmentURL(formState?.invoice_attachment);
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
          newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);

  useEffect(() => {
    setNewFormState(formState);
    setNewFormState((newFormState) => ({
      ...newFormState,
      additionalDocIds: [],
    }));
  }, [formState]);

  //  used for show taxdetail when invoice is created by import.

  //  used for show taxdetail when invoice is created by import.
  useEffect(() => {
    if (formState?.taxCard_List?.length > 0 && formState.isImport) {
      let tempArray = [];
      for (let i = 0; i < formState?.taxCard_List?.length; i++) {
        const item = formState?.taxCard_List[i];
        const obj = {
          taxId: 0,
          invoice_Id: invoicePayload?.Invoice_id,
          taxType: item?.taxType,
          taxCode: item?.taxCode,
          amount: formState.invoice_Amount,
          comments: "",
          created_By: "",
          created_On: new Date(),
          updated_By: "",
          updated_On: new Date(),
          taxCardId: 0,
        };
        tempArray.push(obj);
      }
      setInvoiceTaxDetail((formState) => ({
        ...formState,
        invoice_TaxDetails: tempArray,
      }));
    }
  }, [formState?.taxCard_List]);

  useEffect(() => {
    let total = 0;
    if (formState.invoice_Accounts.length > 0) {
      for (let index = 0; index < formState.invoice_Accounts.length; index++) {
        const item = formState.invoice_Accounts[index];
        total = parseFloat(item.amount ? item?.amount : item?.Amount) + total;
      }

      setGLAccountTotal(total);
    }
  }, [formState?.invoice_Accounts]);

  // invoice_attachment: "",
  // additionalDocIds: "", // paths

  // useEffect(() => {
  //   if (!changed && formState?.additionalDocIds.length > 0) {
  //     setNewFormState((newFormState) => ({
  //       ...newFormState,
  //       additionalDocIds: [],
  //     }));
  //     setChanged(true);
  //   }

  // }, [formState.additionalDocIds]);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  const confirmHandler = (e) => {
    e.preventDefault();
    setOpenWarningBox(true);
  };
  const gltotal = 0;
  useEffect(() => {
    let days = multipleData?.paymentTerms?.filter(
      (item) =>
        item.ReferenceCode === newFormState.invoice_Payment?.paymentTerms
    );
    let date = moment(newFormState?.invoice_Date).format("YYYY-MM-DD");

    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        dueOn: moment(date, "YYYY-MM-DD")
          .add(Number(days[0]?.ReferenceProp1), "days")
          .format("YYYY-MM-DD"),
      },
    }));

    //  newFormState?.invoice_Payment
  }, [
    newFormState?.invoice_Payment?.paymentTerms,
    newFormState?.invoice_Payment?.dueOn,
    newFormState?.invoice_Date,
  ]);

  useEffect(() => {
    // if (newFormState.IsImport && newFormState.IsPSID) {
    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        paymentMethod: "6",
        paymentMethSupp: "C",
      },
    }));
  }, []);

  return (
    <Card>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={dataLoading}
      ></Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>Invoice Detail</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={dataLoading}
          invisible={dataLoading}
        >
          {/* <CircularProgress color="inherit" /> */}
          <Spinner />
        </Backdrop>

        {!formState.isImport && (
          <InvoiceCheckboxes
            formState={formState}
            setFormState={setFormState}
            selectedRole="IP"
            disabled={true}
          />
        )}
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            {!formState.isImport && (
              <InvoiceRadioButtons
                formState={formState}
                setFormState={setFormState}
                selectedRole="IP"
                physicalOrEInvoice={physicalOrEInvoice}
                poBasedState={poBasedState}
                alignForAttachment={false}
              />
            )}

            <InvoiceDetailTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="IP"
              disabled={true}
              edit={false}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              //   setAttchmentFile_UI={setAttchmentFile_UI}
              //   attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              setOpenInvalidWarningDate={setOpenInvalidWarningDate}
              multipleData={multipleData}
            />
            {
              <VFPostingDetail
                newFormState={formState}
                setNewFormState={setFormState}
                multipleData={multipleData}
                changeHandler={changeHandler}
                disabled={true}
                alignForAttachment={true}
              />
            }
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingLeft: "7px" }}
          >
            <Heading title="Attachment Preview">
              <span>
                {attachmentURL != ""
                  ? attachmentURL == formState?.invoice_attachment
                    ? " (Invoice Attachmnets)"
                    : "(Additional Documents)"
                  : null}
              </span>
            </Heading>

            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
            />
          </Grid>
        </Grid>

        <form onSubmit={confirmHandler} style={{ marginTop: "50 px" }}>
          {/* Check boxes */}

          {/*<InvoiceTextField
            newFormState={newFormState}
            setNewFormState={setNewFormState}
            selectedRole="IP"
            edit={true}
            disabled={false}
            poBasedState={poBasedState}
            showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
            showVendorCodeForImport={showVendorCodeForImport}
            invoice_attachmentRef={invoice_attachmentRef}
            additionalAttachmentRef={additionalAttachmentRef}
            setAttachInvoiceLoading={setAttachInvoiceLoading}
            // setAttchmentFile_UI={setAttchmentFile_UI}
            // attachmentFile_UI={attachmentFile_UI}
            physicalOrEInvoice={physicalOrEInvoice}
            changeHandler={changeHandler}
            alignForAttachment={false}
            setAttachmentURLList={setAttachmentURLList}
            attachmentURLList={attachmentURLList}
            setAttachmentURL={setAttachmentURL}
            showAttachmentsHandler={showAttachmentsHandler}
            setOpenInvalidWarningDate={setOpenInvalidWarningDate}
            multipleData={multipleData}
            fields={false}
            />*/}

          {/*  {!formState.isImport && (
          <PaymentDetail
              formState={formState}
              setFormState={setFormState}
              multipleData={multipleData}
              disabled={true}
              alignForAttachment={true}
        


        )}*/}

          {!formState.isImport && (
            <PaymentDetailsTextField
              formState={formState}
              setFormState={setFormState}
              multipleData={multipleData}
              disabled={true}
              alignForAttachment={false}
            />
          )}
          {/* Tax  */}

          <Heading title="Tax" />
          {/* <TaxDetail
            formState={newFormState}
            setFormState={setNewFormState}
            invoice_Amount={newFormState.invoice_Amount}
            edit={"false"}
       />*/}
          <TaxDetailTextField
            formState={newFormState}
            setFormState={setNewFormState}
            invoice_Amount={newFormState.invoice_Amount}
            edit={"false"}
          />
          {formState.isImport ? (
            <TaxTable_Short_Import
              formState={newFormState}
              tempSetFormState={setFormState}
              invoicePayload={invoicePayload}
              invoiceTaxDetail_forImport_Inv={invoiceTaxDetail}
              setInvoiceTaxDetail_forImport_Inv={setInvoiceTaxDetail}
              disabled={true}
            />
          ) : (
            formState.isInitiator && (
              <TaxTable_Short
                formState={newFormState}
                setFormState={setNewFormState}
                tempSetFormState={setFormState}
                invoicePayload={invoicePayload}
                invoiceTaxDetail_forImport_Inv={invoiceTaxDetail}
                setInvoiceTaxDetail_forImport_Inv={setInvoiceTaxDetail}
                disabled={true}
              />
            )
          )}

          <VendorTaxTable formState={formState} setFormState={setFormState} />
          <span></span>
          {formState?.invoice_Accounts?.length > 0 && (
            <>
              <Typography variant="h4" style={{ margin: "20px 0px 10px 0px" }}>
                <Heading title="pG/L Account" />
              </Typography>
              <GL_Table_ProcessInvoice
                formState={formState}
                setFormState={setFormState}
                setGLAccountTotal={setGLAccountTotal}
                importPaymentDetail={importPaymentDetail}
                setImportPaymentDetail={setImportPaymentDetail}
                disabled={true}
              />
            </>
          )}
          {/* G/L Account */}

          {formState?.isImport &&
          formState?.pO_Based &&
          formState?.invoicePORef_List?.length > 0 ? (
            <PoDetail_Table_Import
              // formState={newFormState}
              // setFormState={setNewFormState}

              formState={formState}
              setFormState={setFormState}
              // setSelectedTotal={setSelectedTotal}
              setSelectedTotal={setTotalGrnAmount}
              deletee={false}
              Invoice_id={invoicePayload?.Invoice_id}
              checkedBox={false}
              loading={po_Loading}
              edit={true}
            />
          ) : (
            <>
              {formState?.pO_Based &&
                formState?.invoicePORef_List?.length > 0 && (
                  <PODetail
                    formState={formState}
                    setFormState={setFormState}
                    disabled={true}
                    Invoice_id={invoicePayload?.Invoice_id}
                    setSelectedTotal={setTotalGrnAmount}
                  />
                )}
            </>
          )}

            {!formState.pO_Based && (
            <PaymentImport
              formState={importPaymentDetail}
              vendor={{
                name: formState?.vendor_Name,
                code: formState?.vendor_Code,
              }}
              inv_amount={formState?.invoice_Amount}
              setFormState={setImportPaymentDetail}
              multipleData={multipleData}
              edit={true}
            />
          )}
       
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <CommentHistory
              commentsList={commentsList}
              commentsLoading={commentsLoading}
            />
          </Grid>
          {/* clearing detail */}
          {formState.isImport && formState?.pO_Based && (
            <Grid container spacing={2} style={{ margin: "20px 0px" }}>
              <Grid item xs={12} sm={12} md={3} lg={12}>
                <Typography
                  variant="h4"
                  style={{ margin: "20px 0px 10px 0px" }}
                >
                  <Heading title="Clearing Detail" />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Typography style={{ color: "black" }}>
                  First Clearing Text{" "}
                  <span className={classes.asterisk}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="firstClearText"
                  value={newFormState?.firstClearText}
                  onChange={changeHandler}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Typography style={{ color: "black" }}>
                  Second Clear Text <span className={classes.asterisk}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="secondClearText"
                  value={newFormState?.secondClearText}
                  onChange={changeHandler}
                  disabled={true}
                />
              </Grid>
            </Grid>
          )}
          {formState.isImport && formState?.pO_Based && (
            <Vendor_Table
              formState={newFormState}
              setFormState={setNewFormState}
              disabled={true}
            />
          )}
          {/*  <Grid container style={{ margin: "20px 0px" }}>
            <Grid item xs={12} sm={12} md={3} lg={12}>
              <Typography style={{color:"black"}}>
                comments
                <span className={classes.asterisk}>*</span>
              </Typography>
              <TextField
                fullWidth
                multiline
                // rows={2}
                maxRows={4}
                // size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                name="comments"
                disabled={true}
                value={newFormState.comments}
                onChange={changeHandler}
              />
            </Grid>
              </Grid>*/}

          {/* 3 way check */}
        </form>
      </CardBody>
      {openInvalidWarningDate && (
        <OldDateWarning
          open={openInvalidWarningDate}
          close={() => setOpenInvalidWarningDate(false)}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal}
          close={() => setConfirmationModal(false)}
          message={confirmationMessage}
          submit={() =>
            changeInvoiceStatus(
              formState.invoice_Id,
              statusForPayload,
              setConfirmationModal,
              setAttachInvoiceLoading,
              setSuccessMessage,
              setErrorMessage,
              navigate
            )
          }
          loading={attachInvoiceLoading}
        />
      )}

      {openInvoiceGuideLine && (
        <InvoiceGuideLine
          open={openInvoiceGuideLine}
          close={setOpenInvoiceGuideLine}
        />
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}
      {openWarningBox && (
        <WarningBox
          open={openWarningBox}
          close={() => setOpenWarningBox(false)}
          submit={submitHandler}
          message="Are you sure to Post the invoice to SAP"
        />
      )}
    </Card>
  );
};

export default VFInvoiceDetail;
